import { FAQ } from '@shared/data-structure/interfaces';

export function getDataFaqES(): any {
  const dataFAQs: FAQ[] = [];

  dataFAQs.push({
    question: `¿Qué tipos de libros puedo comprar en Astrea?`,
    answer: `En nuestra tienda podés adquirir obras con el sello editorial de Astrea y también libros de otras editoriales reconocidas. Disponemos de libros en formato físico y digital, según la disponibilidad de cada título.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `¿Cómo sé si un libro está disponible en formato físico o digital?`,
    answer: `Al ingresar a la página de un libro, vas a ver claramente si está disponible en formato físico (con stock para envío o retiro) y/o en versión digital para lectura online en Astrea Virtual.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `¿Cuál es la diferencia entre un libro físico y uno digital?`,
    answer: `Los libros físicos son ejemplares impresos que podés recibir en tu domicilio o retirar en la editorial. Los libros digitales, en cambio, se leen exclusivamente online a través de nuestra plataforma Astrea Virtual, por un período determinado.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `¿Qué opciones de envío ofrecen para libros físicos?`,
    answer: `Realizamos envíos a todo el país a través de Andreani, y al exterior mediante DHL. El costo se calcula automáticamente en el checkout según el peso total y la distancia del envío.`,
    category: 'purchases',
  });
  dataFAQs.push({
    question: `¿Qué datos necesito para realizar una compra?`,
    answer: `Para completar tu compra, deberás registrarte y llenar tus datos personales, de facturación y de envío. Utilizamos esta información exclusivamente para emitir la factura y hacerte llegar tu pedido. Tus datos están protegidos bajo estrictas medidas de seguridad.`,
    category: 'purchases',
  });
  dataFAQs.push({
    question: `¿Qué medios de pago aceptan?`,
    answer: `En Argentina podés abonar con tarjeta de crédito o débito a través de Mercado Pago, con la posibilidad de pagar en hasta 3 cuotas sin interés. Desde el exterior, aceptamos pagos en dólares mediante PayPal.`,
    category: 'payments',
  });
  dataFAQs.push({
    question: `¿Puedo comprar desde el exterior?`,
    answer: `Sí, realizamos envíos internacionales y aceptamos pagos desde el exterior a través de PayPal. Al momento de realizar tu pedido, el sistema calculará automáticamente el costo de envío internacional.`,
    category: 'payments',
  });
  dataFAQs.push({
    question: `¿Cómo accedo a un libro digital que compré?`,
    answer: `Luego de completar tu compra, podrás acceder al libro iniciando sesión en Astrea Virtual con la misma cuenta que usaste para comprar. El acceso estará habilitado por el período de tiempo que seleccionaste al momento de la compra.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `¿Necesito una cuenta en Astrea Virtual para leer un libro digital?`,
    answer: `Sí. Al registrarte en este sitio ya estás creando una cuenta válida tanto para comprar como para acceder a Astrea Virtual. No hace falta registrarte nuevamente.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `¿Por cuánto tiempo tengo acceso a los libros digitales?`,
    answer: `El acceso a cada libro digital dependerá del período que hayas adquirido. El mínimo es de 3 meses, y podés extender el acceso eligiendo más tiempo al momento de la compra.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `¿Puedo imprimir un libro digital que compré?`,
    answer: `En Astrea Virtual está habilitada la impresión parcial de las obras, con una cantidad de páginas limitada. Esta medida busca proteger los derechos de autor y evitar el uso indebido del contenido.`,
    category: 'av',
  });

  return dataFAQs;
}

export function getDataFaqEN(): any {
  const dataFAQs: FAQ[] = [];

  dataFAQs.push({
    question: `What types of books can I purchase from Astrea?`,
    answer: `Our store offers books published by Editorial Astrea as well as titles from other well-known publishers. We offer both physical and digital books, depending on the availability of each title.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `How do I know if a book is available in physical or digital format?`,
    answer: `On each book's page, you'll clearly see whether it is available in physical format (for delivery or in-store pickup) and/or in digital format for online reading through Astrea Virtual.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `What is the difference between a physical book and a digital book?`,
    answer: `Physical books are printed copies that you can have delivered to your home or pick up at our editorial office. Digital books, on the other hand, are read exclusively online through our platform Astrea Virtual, for a selected period of time.`,
    category: 'books',
  });
  dataFAQs.push({
    question: `What shipping options do you offer for physical books?`,
    answer: `We ship nationwide within Argentina via Andreani, and internationally via DHL. Shipping costs are automatically calculated at checkout based on total weight and destination.`,
    category: 'purchases',
  });
  dataFAQs.push({
    question: `What information do I need to place an order?`,
    answer: `To complete your purchase, you must register and provide your personal, billing, and shipping information. This data is used solely to issue your invoice and deliver your order. Your information is protected under strict security standards.`,
    category: 'purchases',
  });
  dataFAQs.push({
    question: `What payment methods do you accept?`,
    answer: `In Argentina, you can pay with credit or debit cards through Mercado Pago, with the option to pay in up to 3 interest-free installments. For international orders, we accept payments in USD via PayPal.`,
    category: 'payments',
  });
  dataFAQs.push({
    question: `Can I make a purchase from outside Argentina?`,
    answer: `Yes, we ship internationally and accept payments from abroad via PayPal. When placing your order, the system will automatically calculate the international shipping cost.`,
    category: 'payments',
  });
  dataFAQs.push({
    question: `How do I access a digital book I purchased?`,
    answer: `After completing your purchase, you can access the digital book by logging into Astrea Virtual using the same account you used to buy it. Access will be granted for the duration you selected at checkout.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `Do I need an Astrea Virtual account to read a digital book?`,
    answer: `Yes. When you register on our site, you're automatically creating a valid account for both purchasing and accessing Astrea Virtual. No additional registration is required.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `How long do I have access to digital books?`,
    answer: `Access to each digital book depends on the period you selected at the time of purchase. The minimum access period is 3 months, and you can choose to extend it when buying.`,
    category: 'av',
  });
  dataFAQs.push({
    question: `Can I print a digital book I purchased?`,
    answer: `Astrea Virtual allows partial printing of digital works, with a limited number of pages. This feature helps protect copyright and prevent unauthorized use of content.`,
    category: 'av',
  });

  return dataFAQs;
}

export function getSchemaFAQ(): object {
  const faq = getDataFaqES();
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faq.map((item: FAQ) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
}
